/* eslint-disable react/prop-types */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated } from 'src/services/auth';

export default function PrivateRoute({
  component: Component,
  location,
  ...rest
}) {
  if (!isAuthenticated()) {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: location.pathname },
        }}
      />
    );
  }
  return <Route {...rest} render={(props) => <Component {...props} />} />;
}
